import { render, staticRenderFns } from "./book-cover.vue?vue&type=template&id=78a07a83&"
import script from "./book-cover.vue?vue&type=script&lang=js&"
export * from "./book-cover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78a07a83')) {
      api.createRecord('78a07a83', component.options)
    } else {
      api.reload('78a07a83', component.options)
    }
    module.hot.accept("./book-cover.vue?vue&type=template&id=78a07a83&", function () {
      api.rerender('78a07a83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/book-cover.vue"
export default component.exports